"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDetailDto = void 0;
const AppDto_1 = require("../apps/AppDto");
class AppDetailDto {
    constructor(params) {
        this.appStoreId = "";
        this.icon = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.appStoreId = params.appStoreId;
        this.icon = params.icon;
        this.totalDownloads = params.totalDownloads;
        this.totalUpdates = params.totalUpdates;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.app !== undefined) {
            this.app = params.app ? new AppDto_1.AppDto(params.app) : null;
        }
    }
}
exports.AppDetailDto = AppDetailDto;
//# sourceMappingURL=AppDetailDto.js.map